/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import { UserResponse } from '../../entities';

export const updateUserResponses = createAction<Record<string, UserResponse>>(
  'userResponses/UPDATE_RESPONSES',
);
